import dayjs from 'dayjs';

import { WELLO_IMAGE_PREFIX_URL } from '@/constants';

export const IMAGE_URL_PREFIX = `${WELLO_IMAGE_PREFIX_URL}/static/event/stamp-2`;

export const EVENT_INFO = {
  START_DATE: dayjs('2025-12-16T00:00:00'),
  END_DATE: dayjs('2025-12-31T23:59:59'),
} as const;

export const REGIONS_DATA = [
  { region: '강원', cities: '강릉' },
  { region: '충북', cities: '진천' },
  { region: '충남', cities: '당진, 논산' },
  { region: '대전', cities: '대전시청, 대전대덕' },
  { region: '경북', cities: '영주' },
  { region: '경남', cities: '통영, 거제' },
  { region: '전북', cities: '임실, 무주' },
  { region: '전남', cities: '전남도청, 영암, 영광, 완도, 고흥' },
  { region: '광주', cities: '광주서구, 광주남구, 광주북구' },
  { region: '제주', cities: '제주도청' },
] as const;
